export const countries = [
  {
    value: 'AR',
    label: 'Argentina',
  },
  {
    value: 'AU',
    label: 'Australia',
  },
  {
    value: 'AT',
    label: 'Austria',
  },
  {
    value: 'BE',
    label: 'Belgium',
  },
  {
    value: 'BR',
    label: 'Brazil',
  },
  {
    value: 'BG',
    label: 'Bulgaria',
  },
  {
    value: 'CA',
    label: 'Canada',
  },
  {
    value: 'CN',
    label: 'China',
  },
  {
    value: 'HR',
    label: 'Croatia',
  },
  {
    value: 'CY',
    label: 'Cyprus',
  },
  {
    value: 'CZ',
    label: 'Czech Republic',
  },
  {
    value: 'DK',
    label: 'Denmark',
  },
  {
    value: 'EG',
    label: 'Egypt',
  },
  {
    value: 'EE',
    label: 'Estonia',
  },
  {
    value: 'FI',
    label: 'Finland',
  },
  {
    value: 'FR',
    label: 'France',
  },
  {
    value: 'DE',
    label: 'Germany',
  },
  {
    value: 'GR',
    label: 'Greece',
  },
  {
    value: 'HU',
    label: 'Hungary',
  },
  {
    value: 'IN',
    label: 'India',
  },
  {
    value: 'IE',
    label: 'Ireland',
  },
  {
    value: 'IL',
    label: 'Israel',
  },
  {
    value: 'IT',
    label: 'Italy',
  },
  {
    value: 'JP',
    label: 'Japan',
  },
  {
    value: 'LV',
    label: 'Latvia',
  },
  {
    value: 'LT',
    label: 'Lithuania',
  },
  {
    value: 'MY',
    label: 'Malaysia',
  },
  {
    value: 'MX',
    label: 'Mexico',
  },
  {
    value: 'NL',
    label: 'Netherlands',
  },
  {
    value: 'NZ',
    label: 'New Zealand',
  },
  {
    value: 'NO',
    label: 'Norway',
  },
  {
    value: 'PL',
    label: 'Poland',
  },
  {
    value: 'PT',
    label: 'Portugal',
  },
  {
    value: 'RO',
    label: 'Romania',
  },
  {
    value: 'RU',
    label: 'Russia',
  },
  {
    value: 'SA',
    label: 'Saudi Arabia',
  },
  {
    value: 'SG',
    label: 'Singapore',
  },
  {
    value: 'SK',
    label: 'Slovakia',
  },
  {
    value: 'SI',
    label: 'Slovenia',
  },
  {
    value: 'ZA',
    label: 'South Africa',
  },
  {
    value: 'KR',
    label: 'South Korea',
  },
  {
    value: 'ES',
    label: 'Spain',
  },
  {
    value: 'SE',
    label: 'Sweden',
  },
  {
    value: 'CH',
    label: 'Switzerland',
  },
  {
    value: 'TH',
    label: 'Thailand',
  },
  {
    value: 'TR',
    label: 'Turkey',
  },
  {
    value: 'UA',
    label: 'Ukraine',
  },
  {
    value: 'AE',
    label: 'United Arab Emirates',
  },
  {
    value: 'GB',
    label: 'United Kingdom',
  },
  {
    value: 'US',
    label: 'United States',
  },
]

export const CountryCodeToLabelMap = Object.fromEntries(countries.map(c => [c.value, c.label]))
